var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhyus5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600 1200",
    style: {
      enableBackground: "new 0 0 1600 1200"
    },
    xmlSpace: "preserve",
    width: "1600px",
    height: "1200px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M228.4,1020.2c49.2,2.2,98.4,3.3,147.6,3.2c1.9,0,1.9-3,0-3c-49.2,0.1-98.4-1-147.6-3.2 C226.5,1017.1,226.5,1020.1,228.4,1020.2L228.4,1020.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M379,945.8c7.7,28.9,14.9,58,21.5,87.2c0.4,1.9,3.3,1.1,2.9-0.8c-6.7-29.2-13.8-58.3-21.5-87.2 C381.4,943.2,378.5,944,379,945.8L379,945.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M513,948c-2.8,27.5-5.6,55.1-8.3,82.6c-0.2,1.9,2.8,1.9,3,0c2.8-27.5,5.6-55.1,8.3-82.6 C516.1,946.1,513.1,946.1,513,948L513,948z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.3,1035.7c17.5,3.1,35.2,4.5,53,4c17-0.5,35.6-1.8,51.8-7.2c1.8-0.6,1-3.5-0.8-2.9 c-16.1,5.3-34.2,6.6-51,7.1c-17.5,0.5-35-0.9-52.2-3.9C400.2,1032.4,399.4,1035.3,401.3,1035.7L401.3,1035.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M380.2,946.8c20.7,5.8,43.2,5.9,64.6,6c23,0.2,46-1.1,68.8-3.7c1.9-0.2,1.9-3.2,0-3 c-22.2,2.6-44.5,3.8-66.8,3.7c-21.7-0.1-44.7-0.1-65.8-5.9C379.1,943.4,378.3,946.3,380.2,946.8L380.2,946.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M371.6,936.5c0.2,1.9,0.4,3.9,0.6,5.8c0.1,1.2,0.1,2.7,0.6,3.8c1.2,2.6,5.2,1.7,7.5,1.7c1.9,0,1.9-3,0-3 c-1.1,0-2.2,0-3.4,0c-1.5,0-1.5-0.3-1.6-1.8c-0.2-2.2-0.4-4.3-0.6-6.5C374.4,934.6,371.4,934.5,371.6,936.5L371.6,936.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M373.6,938.1c25,2.9,50.1,4.3,75.3,4.5c12.4,0.1,24.8-0.1,37.3-0.5c6.2-0.2,12.4-0.5,18.6-0.8 c2.9-0.1,6.9-1.1,9.8-0.5c3.5,0.6,3.3,3.6,3.7,6.7c0.3-0.6,0.7-1.2,1-1.8c-1.3,0-2.6,0-3.9,0c-1.9-0.4-2.7,2.5-0.8,2.9 c2,0.4,3.5,0.4,5.4,0c0.9-0.2,1.2-1.1,1-1.8c-0.5-3.5-0.1-7.9-4.3-8.8c-2.5-0.6-5.6,0.1-8.2,0.2c-3.3,0.2-6.5,0.3-9.8,0.5 c-14,0.6-28.1,1-42.2,1c-27.8,0-55.5-1.3-83.1-4.6C371.7,934.9,371.7,937.9,373.6,938.1L373.6,938.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.3,1010.8c8,10.5,17.4,19.6,28,27.4c1.6,1.1,3.1-1.5,1.5-2.6c-10.2-7.5-19.3-16.3-27-26.4 C396.7,1007.7,394.1,1009.2,395.3,1010.8L395.3,1010.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M388.6,980.3c15.6,22.5,34.8,42.2,57,58.3c1.6,1.1,3.1-1.5,1.5-2.6c-21.7-15.8-40.6-35.2-55.9-57.2 C390.1,977.2,387.5,978.7,388.6,980.3L388.6,980.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M382.5,953.5c27,32,57,61.9,92.8,84.1c1.6,1,3.2-1.6,1.5-2.6c-35.6-22-65.4-51.7-92.2-83.6 C383.4,949.9,381.3,952.1,382.5,953.5L382.5,953.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.2,951.8c25.7,29.9,54.2,58.3,86,81.7c1.6,1.1,3.1-1.5,1.5-2.6c-31.6-23.2-59.9-51.6-85.4-81.2 C412,948.2,409.9,950.3,411.2,951.8L411.2,951.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444,953.9c17.4,21.3,37.4,40.3,59.6,56.6c1.6,1.1,3.1-1.5,1.5-2.6c-22-16.1-41.8-35-59-56.1 C444.9,950.3,442.8,952.4,444,953.9L444,953.9z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M470.8,952.8c11.2,12.6,24,23.4,38.2,32.5c1.6,1,3.1-1.6,1.5-2.6c-14-8.9-26.6-19.7-37.6-32 C471.6,949.2,469.5,951.3,470.8,952.8L470.8,952.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M332.4,788c6.5,13.7,10.9,28.1,13.4,43.1c0.1,0.7,0.8,1.1,1.4,1.1c0.6,0,3.8-0.1,4,0.9 c0.1,0.4-1.9,2.7-2.1,3.2c-0.6,1.6-0.6,3.5,0,5.1c0.8,1.9,2.3,3.2,4.1,3.9c0.6,0.3,1.3,0.4,2,0.5c0.6,0.1,1.2,0.1,1.8,0 c0.8-0.1,0.7,0-0.2,0.4c-1,1.5-2.4,1.7-2.8,3.9c-0.3,2.1,0.7,4.1,1.5,5.9c3.3,7,5.2,14.4,7.9,21.7c9.3,24.8,27.1,45.3,47.2,62.2 c1.5,1.2,3.6-0.9,2.1-2.1c-20.7-17.4-39.1-38.7-47.8-64.8c-1.1-3.4-2.1-6.8-3.3-10.1c-1-2.9-2.9-5.9-3.8-8.8 c-1-1.6-0.9-3.4,0.4-5.2c0.4-0.3,0.8-0.6,1.2-0.9c0.3-0.5,0.9-0.8,1.2-1.4c0.4-1.1,0.1-2.1-0.7-2.9c-1.3-1.3-3.3-0.6-5-1.1 c-6.5-1.9-1.2-6.3-0.7-9.5c0.7-4.2-4.5-3.7-7.3-3.9c0.5,0.4,1,0.7,1.4,1.1c-2.5-15.2-7.1-29.9-13.7-43.8 C334.2,784.7,331.6,786.2,332.4,788L332.4,788z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.5,787.3c32.5,8.7,61,30.8,81.7,57c22,27.8,35.7,61.2,43.1,95.7c0.4,1.9,3.3,1.1,2.9-0.8 c-7.5-35-21.5-68.8-43.8-97c-21-26.5-50-48.9-83-57.7C332.4,783.9,331.6,786.8,333.5,787.3L333.5,787.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M345.3,799.7c39.8,38.7,70.5,86.2,89.4,138.5c0.7,1.8,3.6,1,2.9-0.8c-19.1-52.7-50-100.7-90.2-139.8 C346.1,796.2,343.9,798.3,345.3,799.7L345.3,799.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M363,862.6c8.4,0.9,16.6,2.8,24.4,5.9c7.6,3,15.9,6.8,20.7,13.7c1.1,1.6,3.7,0.1,2.6-1.5 c-4.8-6.9-12.3-10.8-19.9-14c-8.9-3.8-18.2-6.1-27.9-7.1C361.1,859.4,361.1,862.4,363,862.6L363,862.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.9,807.8c-0.1,11.5,1.8,22.8,5.5,33.7c0.6,1.8,3.5,1,2.9-0.8c-3.6-10.6-5.4-21.6-5.4-32.9 C380.9,805.9,377.9,805.9,377.9,807.8L377.9,807.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432.8,862.2c4.9-18.3,21.2-29.2,35.1-40.4c14.8-11.9,29.1-24.6,42.7-37.8c-0.8-0.5-1.7-1-2.5-1.5 c-4.5,12.1-5.4,24.8-5.2,37.6c0.2,12.8,3.1,27.5-1,39.9c0.5-0.4,1-0.7,1.4-1.1c-3.2,0.2-6.4,0.5-9.6,0.7c-1,0.1-2,1.3-1.3,2.3 c2.3,3.1,5,4.1,4.9,8.7c0,3.2-0.8,6.9-1.9,9.9c-1.1,3.1-4,5.2-5,8.1c-0.8,2.6,1.2,4.8,1.2,7.4c0.1,4.3-3,7.9-5.2,11.3 c-2.1,3.2-4,6.5-5.7,9.9c-3.4,6.7-6.1,13.6-8.1,20.8c-0.5,1.9,2.4,2.7,2.9,0.8c2.5-8.9,6.1-17.5,10.8-25.5 c3.2-5.4,9.2-11.7,8.5-18.5c-0.3-2.7-1.7-3.5-0.5-6.6c0.1-0.1,1.9-2.5,2-2.7c1.9-3.1,2.8-6.6,3.4-10.1c0.4-2.6,1.2-5.8,0.8-8.4 c-0.6-3.7-3.4-4-5.5-6.8c-0.4,0.8-0.9,1.5-1.3,2.3c3.2-0.2,6.4-0.5,9.6-0.7c0.7-0.1,1.2-0.4,1.4-1.1c3.8-11.6,1.5-25.1,1.1-37.1 c-0.4-13.7,0.1-27.5,5-40.5c0.6-1.5-1.5-2.4-2.5-1.5c-14.5,14.1-29.7,27.6-45.6,40.2c-13.6,10.8-28.3,21.8-33,39.4 C429.4,863.3,432.3,864.1,432.8,862.2L432.8,862.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M499.5,797c-9.8,17.1-19.8,34-29.2,51.3c-8.8,16-16.6,32.6-20.3,50.5c-0.4,1.9,2.5,2.7,2.9,0.8 c3.8-18.3,11.9-35.1,20.9-51.4c9.2-16.7,18.9-33.1,28.3-49.7C503,796.9,500.4,795.3,499.5,797L499.5,797z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M470,824.8c1.3,5.7,1.9,11.4,1.7,17.2c-0.1,1.9,2.9,1.9,3,0c0.2-6.1-0.4-12-1.8-18 C472.4,822.1,469.6,822.9,470,824.8L470,824.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M486.3,805.7c1.1,4.3,1.3,8.5,0.8,12.8c-0.2,1.9,2.8,1.9,3,0c0.6-4.6,0.3-9.1-0.9-13.6 C488.7,803.1,485.8,803.9,486.3,805.7L486.3,805.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M487,825.6c5.9-3.5,12-6.6,18.3-9.2c1.8-0.7,1-3.6-0.8-2.9c-6.6,2.7-12.9,5.9-19.1,9.5 C483.8,824,485.3,826.6,487,825.6L487,825.6z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M461.2,875.8c3.8-3.2,7.6-6.3,11.5-9.3c4.1-3.2,8.6-7.5,13.6-9.5c1.8-0.7,1-3.6-0.8-2.9c-4.5,1.7-8.2,5-12,8 c-4.9,3.8-9.7,7.6-14.4,11.6C457.6,874.9,459.7,877,461.2,875.8L461.2,875.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M345.4,819.7c7,0.7,14,1.4,21,2c1.9,0.2,1.9-2.8,0-3c-7-0.7-14-1.4-21-2 C343.5,816.5,343.5,819.5,345.4,819.7L345.4,819.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M528.9,1019.2c125.3,0,250.5,0,375.8,0c35.3,0,70.6,0,105.9,0c1.9,0,1.9-3,0-3c-125.3,0-250.5,0-375.8,0 c-35.3,0-70.6,0-105.9,0C526.9,1016.2,526.9,1019.2,528.9,1019.2L528.9,1019.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M952.7,774.2c0,14.6,0,29.2,0,43.8c0,1.9,3,1.9,3,0c0-14.6,0-29.2,0-43.8 C955.7,772.3,952.7,772.3,952.7,774.2L952.7,774.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M883.7,824.7c48.5,0,97,0,145.5,0c1.9,0,1.9-3,0-3c-48.5,0-97,0-145.5,0 C881.8,821.7,881.7,824.7,883.7,824.7L883.7,824.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M916.3,825.5c0,12.6,0,25.2,0,37.9c0,1.9,3,1.9,3,0c0-12.6,0-25.2,0-37.9 C919.3,823.5,916.3,823.5,916.3,825.5L916.3,825.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M991.3,824.7c0,11.1,0,22.3,0,33.4c0,1.9,3,1.9,3,0c0-11.1,0-22.3,0-33.4 C994.3,822.8,991.3,822.8,991.3,824.7L991.3,824.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M943.8,866.3c37.1,0,74.2,0,111.3,0c1.9,0,1.9-3,0-3c-37.1,0-74.2,0-111.3,0 C941.9,863.3,941.9,866.3,943.8,866.3L943.8,866.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M859.9,1048.2c81.9,0,163.8,0,245.7,0c1.9,0,1.9-3,0-3c-81.9,0-163.8,0-245.7,0 C858,1045.2,858,1048.2,859.9,1048.2L859.9,1048.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1198.6,1022.3c80.4,0,160.9,0,241.3,0c22.6,0,45.2,0,67.8,0c1.9,0,1.9-3,0-3c-80.4,0-160.9,0-241.3,0 c-22.6,0-45.2,0-67.8,0C1196.7,1019.3,1196.7,1022.3,1198.6,1022.3L1198.6,1022.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M201.7,1073.5c82.4,0,164.9,0,247.3,0c1.9,0,1.9-3,0-3c-82.4,0-164.9,0-247.3,0 C199.8,1070.5,199.8,1073.5,201.7,1073.5L201.7,1073.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.9,1103.5c67.3,0,134.6,0,201.9,0c1.9,0,1.9-3,0-3c-67.3,0-134.6,0-201.9,0 C365.9,1100.5,365.9,1103.5,367.9,1103.5L367.9,1103.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1391,248.5c0-27.9,0-55.7,0-83.6c0-1.9-3-1.9-3,0c0,27.9,0,55.7,0,83.6C1388,250.4,1391,250.4,1391,248.5 L1391,248.5z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1390.5,164.3c36.1,0,72.2,0,108.3,0c1.9,0,1.9-3,0-3c-36.1,0-72.2,0-108.3,0 C1388.6,161.3,1388.6,164.3,1390.5,164.3L1390.5,164.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1497.3,163c-0.2,28.3-0.4,56.6-0.7,84.9c0,1.9,3,1.9,3,0c0.2-28.3,0.4-56.6,0.7-84.9 C1500.3,161.1,1497.3,161.1,1497.3,163L1497.3,163z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1391,250c35.6,0,71.2,0,106.8,0c1.9,0,1.9-3,0-3c-35.6,0-71.2,0-106.8,0C1389.1,247,1389.1,250,1391,250 L1391,250z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1393.9,170.7c0,23.5,0,46.9,0,70.4c0,1.9,3,1.9,3,0c0-23.5,0-46.9,0-70.4 C1396.9,168.8,1393.9,168.8,1393.9,170.7L1393.9,170.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1396.1,172.2c31.6,0,63.1,0,94.7,0c1.9,0,1.9-3,0-3c-31.6,0-63.1,0-94.7,0 C1394.1,169.2,1394.1,172.2,1396.1,172.2L1396.1,172.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1489.2,171.4c-0.1,23-0.2,46-0.3,69.1c0,1.9,3,1.9,3,0c0.1-23,0.2-46,0.3-69.1 C1492.2,169.5,1489.2,169.5,1489.2,171.4L1489.2,171.4z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1396.7,243c31.1,0,62.2,0,93.3,0c1.9,0,1.9-3,0-3c-31.1,0-62.2,0-93.3,0C1394.8,240,1394.8,243,1396.7,243 L1396.7,243z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1396.1,222.3c11.5-4,23.6-0.4,34.8,2.9c11.4,3.3,22.6,7.3,33.5,11.9c1.8,0.7,2.6-2.2,0.8-2.9 c-12.1-5.1-24.5-9.4-37.1-12.9c-10.7-2.9-22-5.7-32.8-1.9C1393.5,220,1394.3,222.9,1396.1,222.3L1396.1,222.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1434.1,225.7c18.9-1.1,36.6-8.7,55.3-10.8c1.9-0.2,1.9-3.2,0-3c-18.7,2.1-36.4,9.6-55.3,10.8 C1432.1,222.9,1432.1,225.9,1434.1,225.7L1434.1,225.7z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1469.9,189.1c-4.2-2.4-0.4-10.3,4.1-8.4c2.4,1,2.9,3.9,1.6,6c-1.4,2.3-4.3,2.7-6.7,2 c-1.9-0.5-2.7,2.4-0.8,2.9c4,1.1,8.5-0.1,10.5-4c1.8-3.5,0.4-8.1-3.4-9.7c-7.8-3.3-14.2,9.7-6.8,13.8 C1470,192.6,1471.6,190,1469.9,189.1L1469.9,189.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1439.3,162.3c0.1-1.7,0.2-3.4,0.7-5c0.4-1.3,1.4-4.4,2.9-5c2.7-1,3.7,8.5,3.9,10.3c0.2,1.9,3.2,1.9,3,0 c-0.3-3.5-1.1-14.5-6.7-13.7c-2.4,0.3-4.1,3-5,5c-1.2,2.6-1.6,5.5-1.7,8.3C1436.3,164.2,1439.3,164.2,1439.3,162.3L1439.3,162.3z ",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1456.1,628.8c0,12,0,24.1,0,36.1c0,1.9,3,1.9,3,0c0-12,0-24.1,0-36.1 C1459.1,626.9,1456.1,626.9,1456.1,628.8L1456.1,628.8z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1419.8,669.3c27.2,0,54.5,0,81.7,0c1.9,0,1.9-3,0-3c-27.2,0-54.5,0-81.7,0 C1417.9,666.3,1417.9,669.3,1419.8,669.3L1419.8,669.3z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1431.3,670.2c0,5.7,0,11.3,0,17c0,1.9,3,1.9,3,0c0-5.7,0-11.3,0-17C1434.3,668.3,1431.3,668.3,1431.3,670.2 L1431.3,670.2z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1475,671.1c0,6.7,0,13.5,0,20.2c0,1.9,3,1.9,3,0c0-6.7,0-13.5,0-20.2C1478,669.1,1475,669.1,1475,671.1 L1475,671.1z",
    style: {
      fill: "#E8E8E8"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1453.8,695.2c18.9,0,37.8,0,56.7,0c1.9,0,1.9-3,0-3c-18.9,0-37.8,0-56.7,0 C1451.9,692.2,1451.9,695.2,1453.8,695.2L1453.8,695.2z",
    style: {
      fill: "#E8E8E8"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "cat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M761.9,987.6c31.5-21.3,47.3-32,51.4-33.3c10-3.2,42.4-13.5,70.7,3.8c20.3,12.4,39,39.3,31.2,57.3 c-5.6,12.8-22.7,16.8-38.2,20.5c-22.9,5.4-42.5,2.4-53.5-0.2c-4.3,4.2-11.2,9.8-20.9,13.5c-16.1,6.2-34.7,5.1-35.6,1.4 c-0.4-1.9,3.6-5.6,23-13.2c-2.3-2.5-5.7-5.5-10.5-7.6c-14.2-6.5-28.4-0.2-31.1,1.1c13.9,8.1,16.9,12.3,16.2,14.6 c-1.8,5.8-30.1,7.7-37.7-5.6c-0.8-1.3-3-5.8-1.2-14.3C729.3,1010,742.3,1000.9,761.9,987.6z",
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.1,1009.8c3.2-6.6,17.6-5,23.2-4.4c7.2,0.8,13.6,1.5,19.4,6.6c4.4,3.8,10.8,12.1,8.5,18.8 c-2.1,6.4-10,5.9-25.3,13.4c-2.6,1.3-27.6,13.6-25.9,21.7c0.7,3.3,5.2,3.2,19.5,9.3c12.4,5.2,19.7,8.4,25.8,15.4 c3,3.5,9,10.4,7.4,17.4c-3,12.9-29.8,15.1-30.5,13.1c-0.6-1.7,18.2-6.4,18.4-15.2c0.2-6.7-10.3-12.1-16.9-15.6 c-19.4-10.1-32.5-6.5-37.6-16.2c-2.9-5.5-1.3-11.4-1-12.5c1.5-5.4,5.7-10,26.2-20.3c18.7-9.4,27-11.6,26.9-15.8 c-0.1-3.9-7.3-7.1-11.7-8.2c-12.4-3.3-21.5,4.5-25.7,0.1C898,1015.4,898.1,1012,899.1,1009.8z",
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.3,961.4c6.3,4.7,12.6,9.4,18.9,14.1c9-0.9,17.9-1.7,26.9-2.6c5.6-5.4,11.2-10.9,16.8-16.3 c0.4,3.4,1.2,11.1,1.5,14.8c3.5,33.3,3.8,36.2,1.7,40c-6.9,12.3-30.2,17.3-43.6,8.7c-6.5-4.2-9-10.5-13.7-22.6 C731.1,982.9,729.1,970.1,728.3,961.4z",
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M753.7,996c-1.5,3.1-4.8,5-8.2,4.4c-0.9-0.2-1.3,1.3-0.4,1.4c4.1,0.7,8.2-1.3,9.9-5.1 C755.4,995.9,754.2,995.1,753.7,996L753.7,996z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M767.6,995c3.3,3.2,7.7,4.6,12.2,3.9c1-0.1,0.5-1.6-0.4-1.4c-4,0.6-7.9-0.7-10.8-3.5 C767.9,993.3,766.9,994.3,767.6,995L767.6,995z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M762.3,1004.5C762.3,1004.5,762.3,1004.5,762.3,1004.5c-0.3,0-0.5-0.1-0.8-0.1c0.1-0.1,0.1-0.3,0.2-0.4 c0.2,0.2,0.5,0.4,0.7,0.6c0-0.2-0.1-0.3-0.1-0.5c-0.3-0.9-1.7-0.5-1.4,0.4c0.5,2.2,1.3,5.6-1.4,6.7c-0.9,0.4-0.5,1.8,0.4,1.4 c3.6-1.5,3.2-5.4,2.5-8.6c-0.5,0.1-1,0.3-1.4,0.4c0,0.2,0.1,0.3,0.1,0.5c0.1,0.3,0.4,0.6,0.7,0.6c2.6-0.2,0.5-3.8-0.7-1.7 C760.6,1004.5,761.8,1005.3,762.3,1004.5L762.3,1004.5z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M761.3,1005.2c0.5,1.7,0.6,3.6,1.7,5.1c0.9,1.2,2.3,1.8,3.8,1.5c0.9-0.2,0.5-1.6-0.4-1.4 c-2.8,0.6-3.2-3.8-3.7-5.6C762.5,1003.9,761.1,1004.3,761.3,1005.2L761.3,1005.2z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M756.5,1006.6c-2.9-1.3-5.9-1.9-9.1-1.7c-1,0.1-1,1.6,0,1.5c2.9-0.2,5.7,0.3,8.3,1.5 C756.6,1008.3,757.4,1007,756.5,1006.6L756.5,1006.6z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M753.9,1008.6c-2.5,0.2-4.7,1.2-6.4,2.9c-0.7,0.7,0.4,1.7,1.1,1.1c1.5-1.4,3.3-2.3,5.4-2.5 C754.8,1010,754.8,1008.5,753.9,1008.6L753.9,1008.6z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M768.2,1005.9c2.9-1.1,5.8-1.5,8.9-1.2c1,0.1,1-1.4,0-1.5c-3.2-0.3-6.3,0.2-9.3,1.3 C766.9,1004.8,767.2,1006.3,768.2,1005.9L768.2,1005.9z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M770.2,1008.6c2.2-0.3,4.3-0.1,6.4,0.7c0.9,0.3,1.3-1.1,0.4-1.4c-2.2-0.8-4.5-1-6.8-0.7 C769.2,1007.2,769.2,1008.8,770.2,1008.6L770.2,1008.6z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M746.6,991.6c1.5-0.9,3.3-0.9,4.8,0c0.8,0.5,1.6-0.8,0.8-1.3c-2-1.1-4.3-1.1-6.3,0 C745,990.8,745.8,992.1,746.6,991.6L746.6,991.6z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M767.6,989.6c1.5-0.8,3.2-1,5-0.8c0.9,0.1,1.4-1.3,0.4-1.4c-2.1-0.3-4.2,0-6.1,1 C765.9,988.7,766.7,990,767.6,989.6L767.6,989.6z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M743.7,958.2c3.1-1.3,6.2-2.6,9.2-4c-0.6-0.4-1.1-0.8-1.7-1.3c-1.2,3.8-3,7.2-5.4,10.4 c-0.6,0.8,0.4,2,1.3,1.7c3.4-1.3,6.8-2.5,10.2-3.8c1.3-0.5,0.8-2.7-0.6-2.2c-3.4,1.3-6.8,2.5-10.2,3.8c0.4,0.6,0.8,1.1,1.3,1.7 c2.6-3.3,4.4-6.9,5.7-10.9c0.3-1-0.8-1.6-1.7-1.3c-3.1,1.3-6.2,2.6-9.2,4C741.2,956.9,742.4,958.8,743.7,958.2L743.7,958.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M748.7,940c2.1-1.2,4.2-2,6.5-2.5c-0.4-0.6-0.8-1.1-1.3-1.7c-0.9,2-2,4-3.3,5.8c-0.5,0.8,0.2,1.6,1,1.7 c2.7,0.2,5.2-0.5,7.3-2.1c1.1-0.9,0-2.8-1.1-1.9c-1.8,1.4-3.8,2-6.1,1.8c0.3,0.6,0.6,1.1,1,1.7c1.3-1.9,2.4-3.8,3.3-5.8 c0.4-0.9-0.3-1.9-1.3-1.7c-2.5,0.5-4.9,1.4-7.1,2.7C746.3,938.8,747.4,940.7,748.7,940L748.7,940z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M765.2,964.2c-3.3-3.3,2.4-5.2,3-8.1c0.6-3.4-3.4-6.6,1.1-9.2c1.3-0.7,0.1-2.7-1.1-1.9 c-1.6,0.9-2.9,2.3-3.3,4.2c-0.6,3.2,2.2,5.1-0.2,8c-1.1,1.4-2.4,1.8-2.8,3.7c-0.4,1.9,0.4,3.5,1.7,4.9 C764.7,966.8,766.3,965.2,765.2,964.2L765.2,964.2z",
    style: {
      fill: "#161616"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "desk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1041.3,678.7c-250.7,18.1-501.4,36.1-752,54.2c-6.8-181.8-13.6-363.6-20.3-545.4 c251.8-3.4,503.6-6.8,755.4-10.2C1030,344.4,1035.6,511.5,1041.3,678.7z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 3.5,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M482,276c48.6,0,97.3,0,145.9,0c1.9,0,1.9-3,0-3c-48.6,0-97.3,0-145.9,0C480.1,273,480.1,276,482,276 L482,276z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M536.6,288.3c50.1,0,100.2,0,150.3,0c1.9,0,1.9-3,0-3c-50.1,0-100.2,0-150.3,0 C534.6,285.3,534.6,288.3,536.6,288.3L536.6,288.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M299.4,581.7c1.8,41.8,3.6,83.7,5.4,125.5c0.1,1.9,3.1,1.9,3,0c-1.8-41.8-3.6-83.7-5.4-125.5 C302.3,579.8,299.3,579.8,299.4,581.7L299.4,581.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M519.7,557.3c4.3,0,8.6,0,13,0c1.9,0,1.9-3,0-3c-4.3,0-8.6,0-13,0C517.8,554.3,517.8,557.3,519.7,557.3 L519.7,557.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M544,557.3c11.1,0,22.1,0,33.2,0c1.9,0,1.9-3,0-3c-11.1,0-22.1,0-33.2,0C542.1,554.3,542.1,557.3,544,557.3 L544,557.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M602.3,555.7c13.2,0,26.4,0,39.7,0c1.9,0,1.9-3,0-3c-13.2,0-26.4,0-39.7,0 C600.4,552.7,600.4,555.7,602.3,555.7L602.3,555.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M537.6,578.3c16.2,0,32.4,0,48.6,0c1.9,0,1.9-3,0-3c-16.2,0-32.4,0-48.6,0 C535.6,575.3,535.6,578.3,537.6,578.3L537.6,578.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M561,567c18.9,0,37.8,0,56.7,0c1.9,0,1.9-3,0-3c-18.9,0-37.8,0-56.7,0C559.1,564,559.1,567,561,567L561,567z ",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M661.4,673.9c31.8,0,63.7,0,95.5,0c1.9,0,1.9-3,0-3c-31.8,0-63.7,0-95.5,0 C659.5,670.9,659.5,673.9,661.4,673.9L661.4,673.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M739.9,682c16.7,0,33.5,0,50.2,0c1.9,0,1.9-3,0-3c-16.7,0-33.5,0-50.2,0C738,679,738,682,739.9,682 L739.9,682z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M783.6,669.8c16.5,0,32.9,0,49.4,0c1.9,0,1.9-3,0-3c-16.5,0-32.9,0-49.4,0 C781.7,666.8,781.7,669.8,783.6,669.8L783.6,669.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M867.8,398.7c30.5,0,61,0,91.5,0c1.9,0,1.9-3,0-3c-30.5,0-61,0-91.5,0C865.9,395.7,865.9,398.7,867.8,398.7 L867.8,398.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M839.5,403.5c9.7,0,19.4,0,29.1,0c1.9,0,1.9-3,0-3c-9.7,0-19.4,0-29.1,0 C837.5,400.5,837.5,403.5,839.5,403.5L839.5,403.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M845.1,411.6c32.6,0,65.3,0,97.9,0c1.9,0,1.9-3,0-3c-32.6,0-65.3,0-97.9,0 C843.2,408.6,843.2,411.6,845.1,411.6L845.1,411.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M965.8,404.3c6.2,0,12.4,0,18.6,0c1.9,0,1.9-3,0-3c-6.2,0-12.4,0-18.6,0 C963.8,401.3,963.8,404.3,965.8,404.3L965.8,404.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M941.5,526.5c9.2,0,18.3,0,27.5,0c1.9,0,1.9-3,0-3c-9.2,0-18.3,0-27.5,0 C939.5,523.5,939.5,526.5,941.5,526.5L941.5,526.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M923.7,534.6c10,0,20,0,29.9,0c1.9,0,1.9-3,0-3c-10,0-20,0-29.9,0C921.7,531.6,921.7,534.6,923.7,534.6 L923.7,534.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M938.2,542.7c19.7,0,39.4,0,59.1,0c1.9,0,1.9-3,0-3c-19.7,0-39.4,0-59.1,0 C936.3,539.7,936.3,542.7,938.2,542.7L938.2,542.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M975.5,533c5.9,0,11.9,0,17.8,0c1.9,0,1.9-3,0-3c-5.9,0-11.9,0-17.8,0C973.5,530,973.5,533,975.5,533 L975.5,533z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M563.6,408.3c14,0,27.9,0,41.9,0c1.9,0,1.9-3,0-3c-14,0-27.9,0-41.9,0C561.7,405.3,561.7,408.3,563.6,408.3 L563.6,408.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M594.1,416.9c20.6,0,41.3,0,61.9,0c1.9,0,1.9-3,0-3c-20.6,0-41.3,0-61.9,0 C592.2,413.9,592.1,416.9,594.1,416.9L594.1,416.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M648.4,405.4c11.7,0,23.5,0,35.2,0c1.9,0,1.9-3,0-3c-11.7,0-23.5,0-35.2,0 C646.5,402.4,646.5,405.4,648.4,405.4L648.4,405.4z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M290.5,245.8c2.2,75.9,4.4,151.9,6.6,227.8c0.6,21.6,1.2,43.1,1.9,64.7c0.1,1.9,3.1,1.9,3,0 c-2.2-75.9-4.4-151.9-6.6-227.8c-0.6-21.6-1.2-43.1-1.9-64.7C293.5,243.9,290.5,243.9,290.5,245.8L290.5,245.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1017.4,493.9c1.5,50.2,3,100.3,4.5,150.5c0.1,1.9,3.1,1.9,3,0c-1.5-50.2-3-100.3-4.5-150.5 C1020.4,492,1017.4,492,1017.4,493.9L1017.4,493.9z",
    style: {
      fill: "#161616"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M810.3,470.9c0.6,6.1,1.2,12.3,1.7,18.4c5.8-1.5,11.5-3.1,17.3-4.6c-0.8-6.1-1.5-12.3-2.3-18.4 C821.4,467.8,815.9,469.4,810.3,470.9z",
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.8,517.6c6-0.8,11.9-1.5,17.9-2.3c0.8,7.3,1.5,14.6,2.3,21.9c-5.4,0.2-10.8,0.4-16.1,0.6 C809.5,531,808.2,524.3,806.8,517.6z",
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.7,561.9c1.9,6.3,3.8,12.7,5.8,19c5.4-2.5,10.8-5,16.1-7.5c-1.7-5.6-3.5-11.1-5.2-16.7 C839.9,558.5,834.3,560.2,828.7,561.9z",
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,621.5c1.3,19.4,2.6,38.8,3.9,58.1c34-2.2,68-4.3,102-6.5c0.6-17.4,1.3-34.9,1.9-52.3 C505.3,621.1,469.3,621.3,433.4,621.5z",
    style: {
      fill: "#5222D0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 856.1,
    cy: 220.9,
    rx: 7.1,
    ry: 5.9,
    style: {
      fill: "#5222D0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.6,
    cy: 267.1,
    rx: 5.9,
    ry: 3.9,
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 467.5,
    cy: 378.7,
    rx: 4.6,
    ry: 5.4,
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,249.4c1.8-0.3,5.3,16.4,13.9,46.7c11.3,39.9,22.5,72.1,30.6,94.1c-12.3,7.6-39.8,22.1-77.3,22.6 c-26.5,0.3-47.4-6.5-59.8-11.7c24.3,2.7,43.9,2,57.6,0.7c21.7-2,17.9-4.3,34.3-5.1c6.8-0.3,15.7-0.3,24.8-5.8 c3.3-2,5.7-4.2,7.3-5.8c-6.4-13.2-14.6-32.6-21.2-56.9C425,288.7,422.7,249.9,425.3,249.4z",
    style: {
      opacity: 0.21,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519,357.9c1.6,12.7,4.5,26.9,9.3,42.1c13.7,43.2,36.8,74,54.2,93c-10.4,7.7-23.3,15.7-38.8,22.4 c-47,20.3-90.9,17.3-114.4,13.7c-0.9-5.3-1.8-10.6-2.7-15.9c10,0.3,20.6,0.1,31.7-0.5c39.6-2.5,73.6-11.4,100.7-21.3 c-8.6-14.6-14.8-27.2-19.1-36.7c-10.4-22.7-18.1-39.8-20.8-62.9C517.4,377.7,518.1,365.8,519,357.9z",
    style: {
      opacity: 0.25,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.9,424.1c1,22.8,3.4,41.7,5.5,55.3c4.9,31.2,8.5,52.8,21.3,77.1c8,15.1,17,26.2,23.5,33.4 c-11.3,9.7-26.5,20.7-46,29.5c-49,22.3-95,17.8-116.5,14.2c-1.1-4.9-2.2-9.8-3.3-14.8c2.7,0.2,6.9,0.4,12,0.5 c17,0.4,52.4,1,93-12.6c11.4-3.8,27.4-10.2,45.4-20.8c-7.1-9.5-14.1-20.8-20.2-33.9C827.5,500.3,832.3,450.1,836.9,424.1z",
    style: {
      opacity: 0.14,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.5,199.8c2,9.3,4.9,23.5,7.8,41.2c5.4,34.2,5,46.6,11.3,66.8c3.3,10.5,9.2,25.4,20.3,42.4 c-9.3,7.6-20.9,15.5-35.2,22.1c-46.8,21.7-91.6,15.6-112.2,11.3c0.2-4,0.4-8,0.6-11.9c2.6,0.7,6.5,1.6,11.3,2.4 c6.3,1,29.6,4.4,73.4-6.6c12.1-3,28.4-7.8,47.1-15.5c-3.6-6.4-8.9-16.4-13.7-29.2c-14-37.1-13.9-69.3-13.7-85.9 C910.6,227.8,911.2,215.1,913.5,199.8z",
    style: {
      opacity: 0.18,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M315.7,243.7c-9.9,52.4,0.1,105.4,10.1,157c0.4,1.9,3.3,1.1,2.9-0.8c-9.9-51-19.8-103.5-10.1-155.4 C318.9,242.7,316,241.8,315.7,243.7L315.7,243.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M318.5,243.3c14.3,9.6,31.6,11.3,48.5,10.1c19.3-1.4,38.4-5.5,57.5-8.7c1.9-0.3,1.1-3.2-0.8-2.9 c-18.3,3-36.6,6.9-55.1,8.4c-16.9,1.4-34.2,0.1-48.6-9.6C318.4,239.6,316.9,242.2,318.5,243.3L318.5,243.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M422.5,246.8c2.8,47.8,10,96.6,34.2,138.6c1,1.7,3.6,0.2,2.6-1.5c-23.9-41.6-31-89.9-33.8-137.1 C425.4,244.9,422.4,244.9,422.5,246.8L422.5,246.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.3,401.5c22.7,6.6,47.1,2.6,70.2,0.7c20.5-1.7,42.5-2.5,60.1-14.5c1.6-1.1,0.1-3.7-1.5-2.6 c-17.7,12.1-39.9,12.5-60.5,14.2c-22.2,1.8-45.6,5.5-67.5-0.8C327.2,398.1,326.4,401,328.3,401.5L328.3,401.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.7,267.7c-2-0.9,0.2-2.8,1.4-3.1c1.5-0.4,4.4-0.6,5.1,1.1c0.5,1.3-0.3,3-1.5,3.5c-1.9,0.9-4-0.2-5.3-1.5 c-1.4-1.4-3.5,0.7-2.1,2.1c2.5,2.5,6.6,3.8,9.7,1.5c2.5-1.8,3.4-5.8,1.3-8.2c-2.4-2.7-7.5-2.4-10.2-0.4c-2.4,1.8-2.9,6.1,0.2,7.5 C367,271.1,368.5,268.5,366.7,267.7L366.7,267.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M406.8,401.9c-7.2,36.5,0.5,73.4,8.3,109.2c0.4,1.9,3.3,1.1,2.9-0.8c-7.7-35.2-15.3-71.6-8.3-107.6 C410.1,400.8,407.2,400,406.8,401.9L406.8,401.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.1,363.6c23.1-4.4,46.5-6,69.9-5.1c-0.5-0.5-1-1-1.5-1.5c-4.7,48.2,15.9,94.1,40.9,134 c1,1.6,3.6,0.1,2.6-1.5c-24.7-39.5-45.2-84.8-40.5-132.5c0.1-0.8-0.8-1.5-1.5-1.5c-23.7-0.9-47.4,0.8-70.7,5.2 C445.4,361.1,446.2,364,448.1,363.6L448.1,363.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M416.7,513.2c48.6,5.7,97.9-1.6,142.9-20.8c1.8-0.8,0.2-3.3-1.5-2.6c-44.4,19-93.4,26-141.4,20.4 C414.8,510,414.8,513,416.7,513.2L416.7,513.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M466.9,375.9c0-0.1,0.3-0.6,0.3-0.8c0.1-0.4,0.4-0.8,0.7-1.1c0.6-0.5,1.3-0.9,2.1-1c1.5-0.2,2.9,0.6,3.3,2.1 c0.3,1.2-0.2,2.8-1.6,3c-1.3,0.2-2.5-0.7-2.7-2c-0.3-1.9-3.2-1.1-2.9,0.8c0.5,3.5,5,5.2,7.9,3.5c3.2-1.9,3-6.8,0.3-9.1 c-3-2.5-8-1.2-9.7,2.2c-0.8,1.7-0.8,4,1.1,5c1.5,0.8,3.7,0.1,4.1-1.8C470.1,374.8,467.2,374,466.9,375.9L466.9,375.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.6,298.1c26.6,3.7,53-1.8,78.5-9.1c1.9-0.5,1.1-3.4-0.8-2.9c-25,7.1-50.9,12.7-76.9,9.1 C324.5,294.9,323.7,297.8,325.6,298.1L325.6,298.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.6,317.7c13.8,1.5,27.6,0.1,40.9-4.1c1.8-0.6,1.1-3.5-0.8-2.9c-13,4.1-26.5,5.4-40.1,4 C328.7,314.5,328.7,317.5,330.6,317.7L330.6,317.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M330.6,341.9c26.4,3.1,53,1.2,78.6-5.5c1.9-0.5,1.1-3.4-0.8-2.9c-25.4,6.7-51.7,8.5-77.8,5.4 C328.7,338.6,328.7,341.6,330.6,341.9L330.6,341.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.4,495.4c26.5,1.2,53-2,78.4-9.6c1.8-0.5,1.1-3.4-0.8-2.9c-25.2,7.5-51.3,10.7-77.6,9.5 C427.4,492.3,427.4,495.3,429.4,495.4L429.4,495.4z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M434.5,472.5c11.8-0.4,23.6-1.3,35.4-2.6c1.9-0.2,1.9-3.2,0-3c-11.8,1.3-23.5,2.2-35.4,2.6 C432.6,469.6,432.6,472.6,434.5,472.5L434.5,472.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.1,431.3c7.8,1,15.9-1,23.6-2.1c8.5-1.3,16.9-2.5,25.4-3.8c1.9-0.3,1.1-3.2-0.8-2.9 c-7.8,1.2-15.7,2.4-23.5,3.5c-8.1,1.2-16.5,3.4-24.7,2.3C442.2,428,442.2,431,444.1,431.3L444.1,431.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M797.5,207.1c-10.9,53.5-12,108.5-3.3,162.4c0.3,1.9,3.2,1.1,2.9-0.8c-8.6-53.3-7.4-107.9,3.3-160.8 C800.8,206,797.9,205.2,797.5,207.1L797.5,207.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M800.9,207.8c36.3-8.3,73.8-10,110.8-5c1.9,0.3,2.7-2.6,0.8-2.9c-37.5-5.1-75.5-3.4-112.4,5 C798.3,205.4,799.1,208.3,800.9,207.8L800.9,207.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M910.8,200.1c-1.1,51.5-0.4,105.9,25.7,152c1,1.7,3.5,0.2,2.6-1.5c-25.8-45.6-26.4-99.5-25.3-150.5 C913.9,198.2,910.9,198.2,910.8,200.1L910.8,200.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M796.5,371.1c11.2,3.4,23.2,3.6,34.8,3.7c12.5,0.1,25-0.7,37.5-2.4c23.9-3.2,47.2-9.7,69.5-19.1 c1.8-0.7,0.2-3.3-1.5-2.6c-22.3,9.4-45.8,15.8-69.8,18.9c-11.2,1.4-22.5,2.2-33.8,2.1c-11.9,0-24.4-0.1-35.8-3.6 C795.4,367.7,794.7,370.6,796.5,371.1L796.5,371.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M857.7,211c-3.4,1.2-4.9,5.1-3.7,8.4c1.4,3.7,5.7,4.6,8.9,2.4c3.1-2.2,4.1-6.6,1.1-9.4 c-2.6-2.4-7.1-2.5-9.5,0.1c-1.3,1.4,0.8,3.5,2.1,2.1c3-3.2,8.9,1.3,4.8,4.5c-1.6,1.2-3.9,1.2-4.6-0.9c-0.5-1.6,0-3.8,1.7-4.4 C860.3,213.2,859.5,210.3,857.7,211L857.7,211z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M799,253.6c27.3,0.7,54.5,0.2,81.7-1.6c1.9-0.1,1.9-3.1,0-3c-27.2,1.8-54.5,2.4-81.7,1.6 C797,250.6,797,253.6,799,253.6L799,253.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M801.7,268.8c10.2,0.4,20.4,0.8,30.5,1.2c1.9,0.1,1.9-2.9,0-3c-10.2-0.4-20.4-0.8-30.5-1.2 C799.7,265.7,799.7,268.7,801.7,268.8L801.7,268.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M798.9,290c25.7,1.4,51.7,2.6,77-3c1.9-0.4,1.1-3.3-0.8-2.9c-25.1,5.5-50.8,4.3-76.2,2.9 C797,286.9,797,289.9,798.9,290L798.9,290z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.1,615.1c-2.3,20-3.1,40.1-2.4,60.2c0.1,1.9,3.1,1.9,3,0c-0.7-20.1,0.1-40.2,2.4-60.2 C429.3,613.2,426.3,613.2,426.1,615.1L426.1,615.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427.1,616.3c35.6,0,71.3-0.5,106.9-1.6c1.9-0.1,1.9-3.1,0-3c-35.6,1.1-71.3,1.6-106.9,1.6 C425.2,613.3,425.2,616.3,427.1,616.3L427.1,616.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M533.7,613.3c0.3,17.4,0.6,34.7,0.9,52.1c0,1.9,3,1.9,3,0c-0.3-17.4-0.6-34.7-0.9-52.1 C536.7,611.4,533.6,611.4,533.7,613.3L533.7,613.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M423.4,673.1c0.2,6.5,11.5,3.6,15.2,3.4c10.6-0.7,21.2-1.4,31.7-2.2c21.5-1.5,43-2.9,64.5-4.4 c1.9-0.1,1.9-3.1,0-3c-18.3,1.2-36.5,2.5-54.8,3.7c-8.7,0.6-17.4,1.2-26.1,1.8c-2.6,0.2-27.5,2.6-27.6,0.7 C426.4,671.2,423.4,671.2,423.4,673.1L423.4,673.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M435.2,629.8c24-1.1,48-0.2,71.8,2.8c1.9,0.2,1.9-2.8,0-3c-23.8-3-47.8-3.9-71.8-2.8 C433.2,626.9,433.2,629.9,435.2,629.8L435.2,629.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M436.1,645c13.4-1,26.9-2.1,40.3-3.1c1.9-0.1,1.9-3.1,0-3c-13.4,1-26.9,2.1-40.3,3.1 C434.2,642.1,434.2,645.1,436.1,645L436.1,645z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.6,660.3c19.3-2.5,40.3-7.6,59.7-4.1c1.9,0.3,2.7-2.5,0.8-2.9c-19.8-3.6-40.8,1.4-60.5,4 C438.8,657.6,438.7,660.6,440.6,660.3L440.6,660.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M700.7,444.9c-15.9,56.6-13.9,117.2,5.6,172.7c0.6,1.8,3.5,1,2.9-0.8c-19.3-55-21.3-115-5.6-171.1 C704.1,443.8,701.2,443,700.7,444.9L700.7,444.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M702.7,445.9c44.5-0.2,88.8-6,131.9-17.3c1.9-0.5,1.1-3.4-0.8-2.9c-42.8,11.2-86.8,17-131.1,17.2 C700.7,442.9,700.7,445.9,702.7,445.9L702.7,445.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M833.8,426.8c-1.8,27.8-0.6,55.8,4.4,83.3c2.5,13.9,5.5,27.8,11,40.8c5.5,12.9,13.1,24.6,22,35.3 c1.2,1.5,3.4-0.6,2.1-2.1c-9.1-10.9-16.8-23-22.2-36.2c-5.1-12.6-7.9-26.1-10.2-39.4c-4.8-26.9-5.9-54.4-4.2-81.7 C836.9,424.9,833.9,424.9,833.8,426.8L833.8,426.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M706.7,619.2c56.6,4,115.7-2.4,165.3-31.6c1.7-1,0.2-3.6-1.5-2.6c-49.3,29-107.8,35.1-163.8,31.2 C704.8,616,704.8,619,706.7,619.2L706.7,619.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M766.9,454.9c-1.7-2.9,1.7-6.5,4.6-4.2c3.1,2.5-0.2,6.5-3.5,5.2c-1.8-0.7-2.6,2.2-0.8,2.9 c2.7,1.1,6-0.1,7.6-2.5c1.8-2.7,1-6.1-1.5-8c-5.4-4.3-12.2,2.4-9,8.1C765.3,458.1,767.9,456.6,766.9,454.9L766.9,454.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M703.7,489.4c29.9-0.5,59.8-2.6,89.6-6.2c1.9-0.2,1.9-3.2,0-3c-29.7,3.7-59.6,5.7-89.6,6.2 C701.8,486.5,701.8,489.5,703.7,489.4L703.7,489.4z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M804,469.3c0.9,4.6,1.8,9.3,2.7,13.9c0.4,1.9,3.3,1.1,2.9-0.8c-0.9-4.6-1.8-9.3-2.7-13.9 C806.6,466.6,803.7,467.4,804,469.3L804,469.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M806,468.9c5.5-0.8,11-1.6,16.6-2.5c1.9-0.3,1.1-3.2-0.8-2.9c-5.5,0.8-11,1.6-16.6,2.5 C803.3,466.3,804.1,469.2,806,468.9L806,468.9z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M821.7,465.5c0.8,4.3,1.5,8.6,2.3,12.8c0.3,1.9,3.2,1.1,2.9-0.8c-0.8-4.3-1.5-8.6-2.3-12.8 C824.3,462.9,821.4,463.7,821.7,465.5L821.7,465.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M809.2,485.5c5.9-1.2,11.5-2.8,17.1-5c1.8-0.7,1-3.6-0.8-2.9c-5.6,2.1-11.3,3.8-17.1,5 C806.5,483,807.3,485.9,809.2,485.5L809.2,485.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M809.7,472.3c1.1,2.5,2.6,4.5,4.8,6.2c0.8,0.6,2.3,0.6,2.5-0.7c0.8-5.4,2.7-10.2,5.9-14.7 c1.1-1.6-1.5-3.1-2.6-1.5c-3.3,4.6-5.4,9.8-6.2,15.4c0.8-0.2,1.7-0.4,2.5-0.7c-1.9-1.5-3.3-3.3-4.3-5.6 C811.5,469,808.9,470.5,809.7,472.3L809.7,472.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M810.8,515.2c-1.6,7.2-0.9,14.2,2,20.9c0.8,1.8,3.3,0.2,2.6-1.5c-2.6-5.9-3.1-12.3-1.7-18.6 C814.1,514.1,811.2,513.3,810.8,515.2L810.8,515.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M812.8,516.2c6-1,12-1.9,18-2.9c-0.6-0.6-1.2-1.2-1.8-1.8c-1,6.4-0.3,12.5,2.2,18.5c0.7,1.8,3.6,1,2.9-0.8 c-2.3-5.4-3.1-11.1-2.2-16.9c0.2-1.2-0.6-2-1.8-1.8c-6,0.9-12,1.9-18,2.9C810.1,513.6,810.9,516.5,812.8,516.2L812.8,516.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M814.1,536.2c6.6-0.2,12.9-1.5,19.1-3.7c1.8-0.7,1-3.6-0.8-2.9c-5.9,2.2-12,3.4-18.3,3.6 C812.2,533.2,812.2,536.2,814.1,536.2L814.1,536.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M815,522.3c0.9,2.6,2.4,4.4,4.8,5.8c1.1,0.6,2.1-0.2,2.3-1.3c0.6-5.3,2-10.4,4.2-15.3 c0.8-1.7-1.8-3.3-2.6-1.5c-2.4,5.4-3.9,11-4.6,16.8c0.8-0.4,1.5-0.9,2.3-1.3c-1.7-1-2.7-2.2-3.4-4.1 C817.3,519.7,814.4,520.5,815,522.3L815,522.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M817,561.6c0.7,6.7,2.5,13,5.5,19c0.8,1.7,3.4,0.2,2.6-1.5c-2.7-5.5-4.4-11.4-5-17.5 C819.8,559.7,816.8,559.7,817,561.6L817,561.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M818.4,561.3c7.7,0.7,14.9-0.7,21.8-4.1c-0.7-0.3-1.5-0.6-2.2-0.9c1.3,6.1,4,11.4,8.2,16.1 c1.3,1.4,3.4-0.7,2.1-2.1c-3.8-4.3-6.2-9.1-7.4-14.7c-0.2-1-1.4-1.3-2.2-0.9c-6.4,3.1-13.2,4.3-20.3,3.7 C816.5,558.2,816.5,561.2,818.4,561.3L818.4,561.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M825.2,581.7c7.8-2.9,15.5-6,23-9.4c1.8-0.8,0.2-3.4-1.5-2.6c-7.3,3.3-14.8,6.3-22.3,9.1 C822.6,579.5,823.4,582.4,825.2,581.7L825.2,581.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M823.6,566.6c2.4,2.1,7.9,9.3,10.7,4c1.3-2.4,1-5.7,1.8-8.4c1.2-3.8,3.2-7.3,5.8-10.3 c1.2-1.5-0.9-3.6-2.1-2.1c-2.8,3.3-5,6.9-6.3,11.1c-0.6,1.9-1.1,3.9-1.4,5.9c-0.4,2.5-1.1,1.9-3,0.7c-1.2-0.8-2.3-2-3.4-3 C824.3,563.2,822.2,565.3,823.6,566.6L823.6,566.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M706.4,538.3c28-0.3,55.9-2.6,83.5-7c1.9-0.3,1.1-3.2-0.8-2.9c-27.4,4.3-55,6.6-82.7,6.8 C704.5,535.3,704.5,538.3,706.4,538.3L706.4,538.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M703.2,497.7c18.1,0.5,36.1-0.1,54.1-1.6c1.9-0.2,1.9-3.2,0-3c-18,1.5-36.1,2-54.1,1.6 C701.3,494.6,701.3,497.6,703.2,497.7L703.2,497.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M707.5,544.2c19,0.9,38,0.2,56.8-2.2c1.9-0.2,1.9-3.2,0-3c-18.9,2.3-37.9,3.1-56.8,2.2 C705.6,541.1,705.6,544.1,707.5,544.2L707.5,544.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M770.7,540.6c5.4,0.1,10.7-0.6,15.9-2.3c1.8-0.6,1-3.5-0.8-2.9c-4.9,1.6-9.9,2.3-15.1,2.2 C768.8,537.6,768.8,540.6,770.7,540.6L770.7,540.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M717.7,581.8c22.8-1.4,45.5-3.5,68.1-6.6c1.9-0.3,1.9-3.3,0-3c-22.6,3-45.3,5.2-68.1,6.6 C715.7,578.9,715.7,581.9,717.7,581.8L717.7,581.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M720.3,588.8c7.5,0,15,0,22.5,0c1.9,0,1.9-3,0-3c-7.5,0-15,0-22.5,0C718.4,585.8,718.4,588.8,720.3,588.8 L720.3,588.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M726.8,595.5c11.7-0.7,23.4-1.8,35.1-3.2c9.4-1.2,19.5-1.7,27.6-7.2c1.6-1.1,0.1-3.7-1.5-2.6 c-8.5,5.8-19.9,6.1-29.8,7.2c-10.4,1.2-20.9,2.1-31.3,2.8C724.9,592.6,724.8,595.6,726.8,595.5L726.8,595.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M841,514.7c18.2-0.9,36.3-3.3,54.2-7.1c-0.6-0.3-1.2-0.7-1.8-1c8.4,25,20.8,48.3,36.7,69.4 c1.1,1.5,3.8,0,2.6-1.5c-15.7-20.8-28-43.9-36.4-68.6c-0.3-0.8-1-1.2-1.8-1c-17.6,3.8-35.4,6.1-53.4,7 C839,511.8,839,514.8,841,514.7L841,514.7z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M844.1,599.1c2.7,3.8,4.9,7.8,6.8,12.1c0.2,0.6,1.1,0.9,1.7,0.7c14.7-4.9,29.2-10.3,43.4-16.4 c7.2-3.1,14.3-6.3,21.4-9.7c3.4-1.6,6.8-3.3,10.1-5c2-1,4.3-1.6,5-3.8c0.2-0.6-0.1-1.4-0.7-1.7c-0.9-0.5-1.4-0.5-2.3,0 c-0.6,0.3-0.9,1.1-0.7,1.7c0,0.1,0.1,0.2,0.1,0.3c0.5,1.9,3.4,1.1,2.9-0.8c0-0.1-0.1-0.2-0.1-0.3c-0.2,0.6-0.5,1.1-0.7,1.7 c-0.2,0-0.5,0-0.7,0c-0.2-0.6-0.5-1.1-0.7-1.7c-0.6,1.8-6.9,3.7-8.6,4.6c-2.8,1.4-5.6,2.7-8.5,4.1c-6.7,3.2-13.5,6.2-20.4,9.1 c-13.2,5.6-26.7,10.6-40.3,15.1c0.6,0.2,1.1,0.5,1.7,0.7c-1.8-4.3-4.1-8.3-6.8-12.1C845.6,596,843,597.5,844.1,599.1L844.1,599.1 z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M861.5,522.5c-0.2-1.3,2.2-2.5,3.1-1.6c1.2,1.2-0.8,3.4-2.2,2.9c-1.8-0.7-2.6,2.2-0.8,2.9 c4.3,1.6,8.5-4.6,5.2-7.9c-1.5-1.5-3.8-1.4-5.6-0.5c-1.9,1-2.9,2.9-2.5,5C858.9,525.2,861.8,524.3,861.5,522.5L861.5,522.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.4,442.5c11.1,0.2,22.3-0.3,33.3-1.8c11.5-1.6,22.9-4.9,34.6-4.4c1.9,0.1,1.9-2.9,0-3 c-10.7-0.4-21.1,2.3-31.6,3.9c-12,1.9-24.2,2.6-36.4,2.3C416.5,439.5,416.5,442.5,418.4,442.5L418.4,442.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M420,409.4c17,1.3,34-0.2,50.5-4.5c1.9-0.5,1.1-3.4-0.8-2.9c-16.3,4.2-32.9,5.7-49.7,4.4 C418.1,406.3,418.1,409.3,420,409.4L420,409.4z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M804.8,325.2c-1.7,11-3.1,22.9,3.8,32.5c1.1,1.6,3.7,0.1,2.6-1.5c-6.4-8.9-5-20-3.5-30.2 C808,324.1,805.1,323.3,804.8,325.2L804.8,325.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M805.7,325.1c23.8,0.9,47.6-1.4,70.8-6.9c-0.6-0.3-1.2-0.7-1.8-1c2.1,10.3,6.1,19.9,11.7,28.7 c1,1.6,3.6,0.1,2.6-1.5c-5.5-8.6-9.3-18-11.4-28c-0.2-0.8-1.1-1.2-1.8-1c-22.9,5.4-46.4,7.7-70,6.8 C803.8,322,803.8,325,805.7,325.1L805.7,325.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M811.1,357.6c25.8-0.8,51.3-4.6,76.1-11.4c1.9-0.5,1.1-3.4-0.8-2.9c-24.6,6.8-49.8,10.6-75.3,11.3 C809.1,354.7,809.1,357.7,811.1,357.6L811.1,357.6z",
    style: {
      fill: "#161616"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "leg_r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1163.7,1056.1c0,11.3,0,22.5,0,33.8c-80,31.7-96.3,43-95.1,47.1c0.3,1,2.4,4,44.4-0.9 c41.6-4.9,75.3-12,98.7-17.8c-4.1-23.1-8.3-46.2-12.4-69.3C1187.4,1051.4,1175.5,1053.8,1163.7,1056.1z",
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.6,577.8c-2.3,4.3-3.1,7.8-3.3,8.6c-14.3,60.8-33,96.7-45.2,167.2c-23.3,135.8-3.2,290.1-1.3,304.6 c6.4,2.8,18.7,7,34.4,6.4c13.8-0.6,24.5-4.7,30.6-7.6c-2.3-44.3,0-99,15.3-159.3c18.7-73.9,42.4-98.4,63.7-184.8 c15.8-64,34.1-138.5,2.5-160.6C1272.1,535.1,1215.4,547.7,1199.6,577.8z",
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.9,609.7c-16,73-30.9,150.8-43.5,233.1c-11.9,77.4-20.8,151.5-27.4,221.9c10.1-2.1,20.1-4.2,30.2-6.3 c-1.3-31.1,0.1-57.6,2.1-77.9c2.4-25.2,8.5-83.9,33-142.5c3.2-7.5,7.3-16.6,14-33.7c11.3-28.3,19.5-52.5,23.2-63.9 c17.4-54.4,26.1-117.5,28.8-138.3C1295.1,604.5,1275,607.1,1254.9,609.7z",
    style: {
      opacity: 0.2,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.9,736.8c-39.2,51.1-57.5,97.4-66.7,128.5c-8.4,28.3-12.1,53.3-16.9,85.7c-6.8,46-9.4,84.8-10.5,112.4 c6.6-1.6,13.1-3.3,19.7-4.9c-1.1-38.7,1.6-71.8,4.9-97.6c4-30.6,8.6-66.1,24.6-108.8c5.8-15.5,8.6-19.9,21.8-53.4 C1275,772.5,1282.8,751,1287.9,736.8z",
    style: {
      opacity: 0.19,
      fill: "#6D6C6C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "leg_l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1379.7,1044.6c5.6,13.9,11.3,27.8,16.9,41.8c-47,29.9-69.2,47.3-66.7,52.4c3.1,6.3,43.7-6.2,121.8-37.3 c-8.3-27-16.6-53.9-24.9-80.9C1411.1,1028.6,1395.4,1036.6,1379.7,1044.6z",
    style: {
      fill: "#161616"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.1,579c24.5,22.4,23.7,53.8,26.8,105.8c0,0,7.6,127.9,33.1,230.7c6.4,25.7,18,65.6,39.5,113.4 c-3.6,4.6-13.4,15.8-30.6,21.7c-17.6,6-32.6,2.8-38.2,1.3c-30.6-52.2-52.3-96.7-66.3-127.5c-64.9-142.2-70.1-217.1-70.1-256.2 c0-40.2,0.7-88.4,30.6-104.5C1288.4,551.6,1321.4,561,1341.1,579z",
    style: {
      fill: "#EC615B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.7,594.3c11.1,42.7,23.1,86.1,35.9,130.1c33.4,114.2,69.7,222.1,107.8,323.3c3.7-1.9,8.2-4.5,12.8-8 c4.7-3.6,8.4-7.2,11.2-10.4c-5.2-12.1-12.4-29.6-20-51.1c-11.5-32.9-30.2-93.4-39.9-174c-9.3-77.4-14-116.1-13.6-140.5 c0.3-20.1,2.1-61-23.9-83c-5.4-4.5-10.7-7.2-14.4-8.8C1308.9,579.4,1290.3,586.9,1271.7,594.3z",
    style: {
      opacity: 0.15,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1367.1,689.7c-4.6,46.5-6.1,108.8,5.1,180.8c11.3,72.4,31.8,131.5,50.3,174.5c5.7-4.7,11.4-9.4,17.1-14.2 c-6.8-16.1-15.7-38.5-24.6-65.9c-17.1-52.7-24.5-93.8-30.9-130.7C1377.6,796.4,1370.8,747.5,1367.1,689.7z",
    style: {
      opacity: 0.22,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.5,990.3",
    style: {
      fill: "#6D6C6C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M898.9,213.7c-4,2-9.5,5.5-13.8,11.5c-2.3,3.1-5.1,7.2-5.5,13c-0.1,2.3-0.4,7.3,2.8,10.6 c0.9,1,3.3,2.9,15.1,2.5c10.5-0.4,15.8-0.6,18.5-3.4c5.2-5.4,3.3-15.6,0-21.7C910.8,216.5,900.6,214.1,898.9,213.7z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.3,238.8c14.1,16.1,36.7,25.7,78.2,42.8c52.3,21.6,78.5,32.4,109.5,36.2c33.5,4.1,51.4-0.2,57.6,10.7 c8.1,14.1-10.9,40.5-30.5,62.6c-14.6-3.2-29.7-7.2-45.3-12.4c-85.5-28.3-147.3-78.1-187.9-119.5c-5.1,1.1-13.8,2.2-23.7-0.8 c-8.5-2.5-20.5-8.9-19.8-14c0.9-6.2,22.6-7.3,23.9-7.4c-6.6-2.7-16.1-7.3-26.4-14.8c-3-2.2-20.2-14.9-18.1-18.9 c1.8-3.5,17.4,1.3,32.1,5.8c13.4,4.1,22.7,7,32.9,14C951.6,229.7,957.3,236.5,959.3,238.8z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M890.1,214.8c2.4,2.7,2.9,6.3,5,9.1c1.8,2.5,4.4,4.3,7.1,5.8c8.1,4.5,16.7,8.2,25,12.3 c1.4,0.7,3.2-1.2,1.8-2.4c-4.3-3.7-8.9-7-13.7-10c-1.6-1-3.2,1.6-1.5,2.6c4.6,2.9,9,6,13.1,9.5c0.6-0.8,1.2-1.6,1.8-2.4 c-7.9-3.8-15.8-7.5-23.6-11.6c-3.7-1.9-7-4.1-8.9-7.9c-1.3-2.6-2-5.1-4-7.3C890.9,211.3,888.8,213.4,890.1,214.8L890.1,214.8z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M897.9,225.3c4.6,2,9,4.6,13,7.7c1.5,1.2,3.6-0.9,2.1-2.1c-4.2-3.3-8.7-6-13.6-8.2 C897.6,221.9,896.1,224.5,897.9,225.3L897.9,225.3z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M886.1,213c3.8,6.1,8.8,11.1,14.7,15.1c1.6,1.1,3.1-1.5,1.5-2.6c-5.5-3.7-10.1-8.4-13.6-14.1 C887.7,209.9,885.1,211.4,886.1,213L886.1,213z",
    style: {
      fill: "#FFFFFF"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M890.6,221.2c2,2.7,4.2,5.2,6.7,7.4c1.8,1.6,9.7,7.3,5.6,10.2c-0.8,0.5,0,1.8,0.8,1.3c2.8-1.9,1.7-5.3,0-7.6 c-1.3-1.7-3.1-3-4.8-4.5c-2.6-2.3-4.9-4.8-7-7.5C891.3,219.6,890,220.4,890.6,221.2L890.6,221.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M888.5,231.6c3,4.1,8.7,9.9,14.3,8.2c0.9-0.3,0.5-1.7-0.4-1.4c-4.8,1.5-10.1-4-12.6-7.5 C889.2,230.1,887.9,230.8,888.5,231.6L888.5,231.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M884.1,238.6c3.3,4.5,8.1,7.1,13.7,7.4c1,0.1,1-1.4,0-1.5c-5-0.3-9.4-2.7-12.4-6.7 C884.8,237,883.5,237.8,884.1,238.6L884.1,238.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M880.9,247.6c4.7,4.9,12.5,5,17.2,0c0.7-0.7-0.4-1.8-1.1-1.1c-4.1,4.4-10.9,4.3-15,0 C881.3,245.8,880.2,246.9,880.9,247.6L880.9,247.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M881.9,212.8c11.1,7.3,19.1,19.6,33,22c0.9,0.2,1.4-1.3,0.4-1.4c-13.7-2.3-21.7-14.6-32.6-21.8 C881.8,210.9,881.1,212.2,881.9,212.8L881.9,212.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M880.7,245.5c-3.6-4.9-0.6-15.4,8.1-25.3c9.8,5.7,19.5,11.5,29.3,17.2c-1.8,0-17.6,0.2-18.7,5.1 c-0.2,0.8,0,2,1.5,3.7c5,2.4,13.4,5.6,24.2,5.9c5.6,0.1,10.5-0.6,14.3-1.5c20.4,20.6,56.3,51.7,109.1,74.3 c46.4,19.8,88,25.5,115.5,27.1c-0.9,11.8-1.8,23.5-2.7,35.3c-45.3-12-106.7-34.8-167.7-80.6c-20.8-15.6-38.6-31.7-53.8-47.2 c-14,2.3-22.7-0.1-28.2-2.9c-4.7-2.4-7.7-5.4-13.9-5.9c-4.1-0.3-7.6,0.7-12.1-1.5C885.1,249,882.2,247.5,880.7,245.5z",
    style: {
      opacity: 0.2,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.5,316.1c14,7.5,30.2,15.1,48.7,21.6c40.3,14.3,76.8,18.8,104.7,19.8c-0.4,10.2-0.7,20.5-1.1,30.7 c-29-6.8-65.4-18.7-104-40.3C1039.3,337.6,1023.3,326.7,1009.5,316.1z",
    style: {
      opacity: 0.14,
      fill: "#6D6C6C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1167.6,344.6c-5.7,12.9-6,23.6-6.5,42.8c-0.4,14.5,0.6,30.1,8.4,71.1c9.5,49.6,14,57.6,15.5,83.9 c1.2,20.6-0.4,37.5-1.9,48.7c12.6,6.9,33.7,16.3,61.3,18.4c48.8,3.7,84.9-17.8,97.3-26c1.5-31.4,3-62.9,4.6-94.3 c-5.5-26.8-12-47.8-16.7-61.6c-14.8-43.5-28.6-64.1-19.8-85.9c4.9-12.1,14.6-19.5,21.3-23.6c-4.7-3.6-54-40.1-107.8-21.2 C1217.7,298.8,1182.3,311.3,1167.6,344.6z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.1,296.8c15,24,23.4,45.2,28.2,60c0,0,23.5,71.4,6.3,167.2c-3.7,20.4-10.3,49.4-23.3,82.6 c5,1.1,11,2,17.8,2.3c0,0,10.5,0.5,22.3-1c14.4-1.9,39.1-9.6,68.2-24.4c0.5-33.5,1-66.9,1.5-100.4c-7.4-28.3-14.9-51-20.5-66.9 c-13.5-37.9-23-55.7-15.2-74.5c5.1-12.3,15.5-19.9,23.6-24.3c-10.6-7-30.2-17.9-57-22.1C1252.9,291.9,1234.7,294.3,1223.1,296.8z",
    style: {
      opacity: 0.19,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.8,294.5c16.1,19.8,34.9,48.7,46.5,86.8c32.9,108.8-21.2,204.2-33.7,225.1c10.5-0.1,22.8-1,36.2-3.6 c23.9-4.6,43-12.8,56.7-20.1c0.5-31.2,1-62.4,1.5-93.5c-8.5-28.9-16.5-56.3-27.4-93.5c-7.4-25.5-13.2-46.4-2.3-63.1 c5.3-8.1,12.7-12.6,18.3-15.2C1300.7,309.7,1268.7,302.1,1236.8,294.5z",
    style: {
      opacity: 0.11,
      fill: "#6D6C6C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "files"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1229.4,498.8c-0.3-21.4-0.5-42.7-0.8-64.1c51.3-2.6,102.6-5.2,154-7.8c1.8,19.8,3.6,39.6,5.5,59.4 C1335.2,490.5,1282.3,494.6,1229.4,498.8z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.8,491.8c0-7.8,0-15.6,0-23.4c65.9-4.9,131.8-9.9,197.7-14.8c0.5,9.6,1,19.3,1.6,28.9 C1346.7,485.5,1280.2,488.7,1213.8,491.8z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.3,456.6c0.8,11.5,1.6,22.9,2.3,34.4c61-4.9,121.9-9.9,182.9-14.8c0.5-10.4,1-20.8,1.6-31.3 C1343.8,448.8,1281.5,452.7,1219.3,456.6z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.4,482.4c1.8,45.6,3.6,91.2,5.5,136.8c68-7.6,136-15.1,204-22.7c2.1-44.8,4.2-89.6,6.3-134.4 C1348.2,468.9,1276.3,475.6,1204.4,482.4z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1216,500.2c30.9-4.1,61.8-7,92.9-8.8c1.4-0.1,1.4-2.3,0-2.3c-31.1,1.8-62.1,4.7-92.9,8.8 C1214.6,498.1,1214.6,500.4,1216,500.2L1216,500.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1250.5,506.3c23.7-3,47.4-6.1,71.2-9.1c1.4-0.2,1.4-2.4,0-2.3c-23.7,3-47.4,6.1-71.2,9.1 C1249.1,504.3,1249.1,506.5,1250.5,506.3L1250.5,506.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1364.4,570.3c-0.4,6.3-0.4,12.7,0.2,19c0.1,1.4,2.4,1.4,2.3,0c-0.6-6.3-0.7-12.7-0.2-19 C1366.8,568.9,1364.5,568.9,1364.4,570.3L1364.4,570.3z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1365.4,570.5c12.4,0.3,24.7-0.4,37-2c-0.4-0.4-0.8-0.8-1.1-1.1c-0.2,5.8,0,11.5,0.4,17.2 c0.1,1.4,2.4,1.4,2.3,0c-0.5-5.7-0.6-11.5-0.4-17.2c0-0.6-0.5-1.2-1.1-1.1c-12.3,1.6-24.6,2.2-37,2 C1363.9,568.2,1363.9,570.4,1365.4,570.5L1365.4,570.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1366.3,591.1c12.3,0.2,24.4-1.1,36.4-3.8c1.4-0.3,0.8-2.5-0.6-2.2c-11.8,2.6-23.7,3.9-35.8,3.7 C1364.9,588.8,1364.9,591,1366.3,591.1L1366.3,591.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1371,577.5c7.6,0.5,15.1,0.1,22.7-1.1c1.4-0.2,0.8-2.4-0.6-2.2c-7.3,1.2-14.7,1.5-22.1,1 C1369.6,575.1,1369.6,577.4,1371,577.5L1371,577.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1375.8,583.8c7.9-0.2,15.5-1.7,23-4.4c1.3-0.5,0.8-2.7-0.6-2.2c-7.2,2.7-14.7,4.1-22.4,4.4 C1374.4,581.5,1374.3,583.8,1375.8,583.8L1375.8,583.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1236.7,614c1.8-42.2,3.6-84.4,5.3-126.7c58.4-4.7,116.9-9.3,175.3-14c-1.3,40-2.7,80-4,120 C1354.4,600.2,1295.6,607.1,1236.7,614z",
    style: {
      opacity: 0.2,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.3,446c0.3,11.6-0.3,25.4-3.3,40.7c-7.4,37.6-25.2,64.7-37.3,80c8.2,10.9,16.4,21.8,24.7,32.7 c-25.1,2.9-50.2,5.8-75.3,8.7c4-45.8,8-91.6,12-137.3c-1.3-6-2.7-12-4-18C1339.8,450.4,1367.6,448.2,1395.3,446z",
    style: {
      opacity: 0.2,
      fill: "#6D6C6C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand_l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1325.7,315.4c20.9-2.8,45.8,45.2,55.7,79.7c11.4,39.7,6.4,74,2.3,92.1c-8,35.5-24.6,60.5-35,74 c1.6,5.3,5.3,19.7-0.8,35.5c-9,23.1-33.4,34.2-35.3,32.1c-0.6-0.7,0.6-3.6,10.1-14.5c-2,2.1-16.4,16.4-32.6,13 c-2.8-0.6-6.3-1.3-8.3-4.1c-4.7-6.8,3.1-22.2,19.7-39.3c-18.1,4.5-22.9,3.3-23.8,1.3c-2.3-4.8,16.2-18.4,22.9-23.4 c9.9-7.3,18.8-12.3,24.9-15.4c17.1-35.5,16.2-63.2,14.7-76.2c-2.2-19.2-9.4-40.1-10.8-44.1c-4-11.5-5.9-14.1-13.9-34.8 c-12.9-33.2-12.9-38.9-12.4-43.3C1304.9,334.8,1313.8,317,1325.7,315.4z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1282.2,620.4c11.1-6.3,20.8-14.4,28.9-24.2c1.2-1.5-0.9-3.6-2.1-2.1c-7.9,9.6-17.4,17.6-28.3,23.8 C1279,618.7,1280.5,621.3,1282.2,620.4L1282.2,620.4z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1292,627.1c11-5.7,20.4-13.6,28-23.4c1.2-1.5-1.4-3-2.6-1.5c-7.2,9.4-16.4,16.9-26.9,22.3 C1288.8,625.4,1290.3,628,1292,627.1L1292,627.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1317.3,320.2c-19.9,17.3,61.3,93.2,47.4,179.4c-9.5,59.1-48.9,97.7-48.9,97.7c-11,11-31.7,24.5-29.2,29.2 c1.8,3.4,14.3,0.3,18.8-1.1c8.5-2.6,14.4-7,17.7-9.9c-5,5.6-10.7,12.5-9.5,13.9c1.7,1.8,15.9-5.6,24.8-16 c15.4-18,13.2-43,11.7-53.2c3.6-4.7,8.3-11.3,13.1-19.7c4.4-7.5,17.1-30.9,22.6-62.7c9.7-56.3-10.2-100.7-18.2-118.1 c-7.2-15.5-19.4-41.2-37.9-42.3C1327.3,317.1,1321.2,316.8,1317.3,320.2z",
    style: {
      opacity: 0.17,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.7,476.2c-5.4,15.7-11.8,32.2-19.4,49.5c-5.4,12.3-10.9,23.8-16.5,34.7c-2.8,9-8.1,22.5-18.6,36.4 c-11,14.6-23.1,23.5-31.2,28.6c2.3,0.1,5.1-0.1,8.2-0.9c7.8-1.8,13-6.1,15.6-8.7c-3,3.8-6.1,7.5-9.1,11.3c2.4-0.4,6.2-1.1,10.4-3 c22-9.9,26.6-36.8,26.9-38.6c0.8-4.9,1.3-13.3-1.7-23.7c7.2-8.5,16.3-21.2,23.6-38.3C1381,504.7,1383.7,487.8,1384.7,476.2z",
    style: {
      opacity: 0.22,
      fill: "#6D6C6C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1144.6,249.6c-16.1,18.4-5,44.1-3.5,47.6c5.6,13,20.1,31.5,38.5,30c13.4-1.2,21.9-12.5,24-15.5 c14.8-21.3,9.9-62-15.1-72.5C1174.7,233.4,1155.7,236.8,1144.6,249.6z",
    style: {
      fill: "#5222D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.2,266c0.7,7.9,9,9.6,14.6,22.6c4,9.4,4,18.6,3.3,25.2c6.5,0.6,18.5,0.9,32.1-4.3 c10.7-4.1,18.2-10,22.7-14.1c-2.1-4.7-5.2-11.6-8.9-19.8c-16-34.9-18.6-37.9-22.5-39.4C1210.9,230.3,1183.9,251.3,1185.2,266z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.6,162.7c-3.4,4.8-5.5,10.7-5.8,36c-0.2,21.6,1,41.3,3,58.8c4.5-2.6,9-5.2,13.5-7.8 c2,4.9,5.4,11.6,11.2,18.1c11.5,12.9,25.5,17.3,31.7,18.9c6.5-1.6,22.7-6.6,35-21.9c8.1-10.2,10.7-20.3,11.3-22.6 c3.7-15.1,0.1-27.6-1.8-32.8c2.4-1.1,6.1-3.2,8.9-7c5.9-8,7.5-22.3,0.2-27.1c-5.4-3.6-15-1.5-22.2,5.9c-1.6-3.7-4.1-8.8-8.1-14.1 c-1-1.3-8.5-11.1-17.7-16.2C1169.1,140.7,1139.8,145.5,1127.6,162.7z",
    style: {
      fill: "#FFFFFF",
      stroke: "#161616",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.3,194.1c-4-0.7-11.4-2.8-14.9-8.9c-6-10.3,2.8-26,5-29.9c1.8-3.3,6.6-11.2,27-25.5 c15.5-10.9,23.3-16.3,31.7-18.9c29.8-8.9,57.1,6.5,62.2,9.4c10.7,6.1,17.5,12.7,22.9,17.9c8.3,8,17.6,17.2,28,27.8 c26.7,34.6,36.1,66.2,39.9,85.1c4.3,21.4,8.7,43.2-4.1,56c-12.8,12.8-36.2,10.2-50.5,4.1c-19.9-8.5-28.4-26.5-35-40.4 c-11.2-23.8-11.9-46.6-10.8-61.4c10-2.9,15.1-12.3,12.8-19.4c-1.8-5.6-8.5-11.2-15.4-9.2c-5.3,1.5-9.1,7-8.8,13.4 c-4.8-0.1-17.6-1.2-29.8-10.4c-8.9-6.7-13.4-14.7-15.5-19.1c-5.5,0.7-16.5,2.7-27.6,10.7C1128.1,181.8,1122.9,189.5,1120.3,194.1z",
    style: {
      fill: "#5222D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.5,213.2c12,14.5,15.8,29.8,15.8,29.8c3.9,17.2-1.7,31.8-4.2,37.7c6.3-4.8,12.7-9.6,19-14.4 c4.4,14.6,8.7,29.1,13.1,43.7c3.3-0.3,10.1-1.5,16.9-6.3c5.2-3.7,8.3-8,10-10.7c-8.1-7.5-23.6-24.1-30.7-50.2 c-3.4-12.6-3.9-23.8-3.5-32.2c9.1-3.7,13.8-12.6,11.9-20c-1.4-5.4-6.9-11.9-14-10.9c-5.9,0.9-10.8,6.7-10.7,13.8 c-4.5,0-15.1-0.5-26.2-7.2c-11.5-6.9-17-16.5-19.1-20.6c0.5,19.2,6.4,30.3,11.7,36.9C1180,207.1,1181.6,207.3,1186.5,213.2z",
    style: {
      opacity: 0.24,
      fill: "#6D6C6C"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1140,209c-1.1,4-1,8.1,0.5,12c0.5,1.4,2.4,1.5,2.9,0c1.2-3.6,1.2-7.4,0.1-11c-0.6-1.8-3.5-1.1-2.9,0.8 c1,3.2,0.9,6.3-0.1,9.5c1,0,1.9,0,2.9,0c-1.3-3.4-1.5-6.9-0.5-10.4C1143.4,207.9,1140.6,207.1,1140,209L1140,209z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1136.4,202.8c2.6-1.6,5.8-1.3,8,0.8c1.4,1.3,3.5-0.8,2.1-2.1c-3.1-3-7.9-3.6-11.6-1.3 C1133.3,201.2,1134.8,203.8,1136.4,202.8L1136.4,202.8z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1147.2,228.2c1.9,0,1.9-3,0-3C1145.2,225.2,1145.2,228.2,1147.2,228.2L1147.2,228.2z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1153.8,219.5c0,0.1,0,0.2,0,0.3c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5c0-0.1,0-0.2,0-0.3 c0-0.8-0.7-1.5-1.5-1.5C1154.5,218,1153.8,218.6,1153.8,219.5L1153.8,219.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1154.1,227c1.9,0,1.9-3,0-3C1152.2,224,1152.2,227,1154.1,227L1154.1,227z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1112.9,213.6c-1.2,4-1.1,8.1,0.3,12c0.5,1.4,2.4,1.4,2.9,0c1.2-3.6,1.3-7.4,0.3-11 c-0.5-1.9-3.4-1.1-2.9,0.8c0.9,3.2,0.8,6.3-0.3,9.4c1,0,1.9,0,2.9,0c-1.2-3.4-1.4-6.9-0.3-10.4 C1116.3,212.5,1113.4,211.7,1112.9,213.6L1112.9,213.6z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1111.2,206.1c2.1-1.1,5-0.6,6.4,1.4c1.1,1.5,3.7,0,2.6-1.5c-2.5-3.3-6.8-4.4-10.5-2.5 C1108,204.4,1109.5,207,1111.2,206.1L1111.2,206.1z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1144.9,260.5c7.7-1.4,14.4-5.5,19.4-11.6c0.9-1.1-0.7-2.7-1.6-1.6c-4.7,5.8-11,9.6-18.4,11 C1142.9,258.6,1143.5,260.8,1144.9,260.5L1144.9,260.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1160.5,247.5c1.8,0.6,3.3,1.5,4.6,2.8c1,1,2.6-0.6,1.6-1.6c-1.6-1.6-3.5-2.7-5.6-3.4 C1159.7,244.9,1159.1,247.1,1160.5,247.5L1160.5,247.5z",
    style: {
      fill: "#161616"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1222.8,116.7c12.7,17.6,29,42.5,44.5,74.3c16.4,33.6,28.4,58.9,19.1,68.9c-12.3,13.3-54.8-7.8-61.6-11.3 c1.4,9.1,4.9,23.6,15.2,38.1c5.2,7.3,14.3,20.2,31.1,26.2c10.1,3.6,19.1,3.4,22.6,3.1c4.7-0.3,10.1-0.7,16-3.9 c0,0,7.7-4.1,12.9-12.5c7.9-12.8,3.7-30.1-1.9-51.8c-6.7-26-15.7-43.3-24.5-60.4c-2.2-4.2-4.8-9.1-9-14.8 c-4.2-5.8-7.3-8.9-20.3-21.4c-19.3-18.7-22.3-21.4-28.1-25.3C1232.4,121.5,1226.7,118.6,1222.8,116.7z",
    style: {
      opacity: 0.45,
      fill: "#371B9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.7,286.8c0.8,2.3,2.6,8.8,0,16c-3.9,10.7-14.7,14.3-16.4,14.8c-12.3,4-27.8-2.3-38.2-16 c1.4,3.6,4.5,10,10.9,15.6c3.2,2.8,11.9,10.3,24.2,9.4c2.1-0.2,15.6-1.2,21.8-12.9C1205.5,305.4,1204.5,295,1198.7,286.8z",
    style: {
      opacity: 0.43,
      fill: "#371B9B"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyus5);
export default __webpack_public_path__ + "static/media/whyus_5.e078a9fb26153a0fabbc98bf3f889c08.svg";
export { ForwardRef as ReactComponent };